import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {DealModel} from "../deal.model";
import {IconComponent} from '../../ui-elements/icon/icon.component';

@Component({
    selector: "woa-deal-summary-icon",
    templateUrl: "./deal-summary-icon.component.html",
    styleUrl: "./deal-summary-icon.component.scss",
    imports: [
        IconComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealSummaryIconComponent {
    public dealModel: DealModel = inject(DealModel);
}
